module.exports = __webpack_public_path__ + "static/media/sec6_banner_player_2008.15464b1c.png";